var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "TableTask" } },
    [
      _c("VisitorTaskListView", {
        ref: "taskListView",
        attrs: { tableRecord: _vm.recordId, showCreateButton: true },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }